'use strict';

function MarketAnalysisDemandAdjustmentTimeOfDayBucketController($scope, stateService) {
  $scope.DEFAULT_BUCKET = 3;
  $scope.state = {
    currentBucket: null
  };
  $scope.applyBucket = function () {
    stateService.setState('TOD', $scope.state.currentBucket || $scope.DEFAULT_BUCKET);
    $scope.getServiceShareData();
  };
}
MarketAnalysisDemandAdjustmentTimeOfDayBucketController.$inject = ['$scope', 'TimeOfDayBucketStateService'];
module.exports = MarketAnalysisDemandAdjustmentTimeOfDayBucketController;